import { BaseFetch } from "../main-model"
export default class AnnBoardInfoModel extends BaseFetch {
    getAnnBoaInfoBy = (data) =>
    this.authFetch({
      url: "ann-boa-info/getAnnBoaInfoBy",
      method: "POST",
      body: JSON.stringify(data),
    })
    getAnnBoaInfoById = (data) =>
    this.authFetch({
      url: "ann-boa-info/getAnnBoaInfoById",
      method: "POST",
      body: JSON.stringify(data),
    })
    updateAnnBoaInfoById = (data) =>
    this.authFetch({
      url: "ann-boa-info/updateAnnBoaInfoById",
      method: "POST",
      body: JSON.stringify(data),
    })
    insertAnnBoaInfo = (data) =>
    this.authFetch({
      url: "ann-boa-info/insertAnnBoaInfo",
      method: "POST",
      body: JSON.stringify(data),
    })
    deleteAnnBoaInfoById = (data) =>
    this.authFetch({
      url: "ann-boa-info/deleteAnnBoaInfoById",
      method: "POST",
      body: JSON.stringify(data),
    })
}
